<template>
<div>
    <div class="background-image" :style="`height: 500px; background-image: url(/wp-content/themes/rhiza/src/assets/header-autor1.jpg)`">

    </div>
    <div class="container bg-white header-contato">
        <div class="row pt-4 pb-5">
            <div class="col-xl-3 col-12 d-flex justify-content-center align-items-center">
                <div class="rounded-photo background-image" :style="`background-image: url(${autor.foto.url});`"></div>
            </div>
            <div class="col-xl-6 col-12">
                <p class="font-glacial-bold font-56 margin-0 text-xl-left text-center">{{autor.nome}}</p>
                <p class="font-glacial-bold text-uppercase font-11 text-categories-red text-xl-left text-center">
                    <b-img src="\wp-content\themes\rhiza\src\assets\line2.png"></b-img>
                    {{autor.cargo}}
                </p>
                <p class="font-glacial-regular font-20 font-italic text-xl-left text-center">{{autor.subtitle}}</p>
            </div>
            <div class="col-xl-3 col-12">
                <div class="pt-4 d-flex justify-content-center">
                    <a  v-bind:href="autor.facebook" target="_blank">
                        <b-img class="pr-3 btn-pointer" src="\wp-content\themes\rhiza\src\assets\social-face.png"></b-img>
                    </a>
                    <a v-bind:href="autor.instagram" target="_blank">
                        <b-img class="btn-pointer" src="\wp-content\themes\rhiza\src\assets\insta-social.png"></b-img>
                    </a>
                </div>
            </div>
        </div>
        <div class="row d-flex justify-content-center pb-5">
            <p class="col-10 font-glacial-regular font-20 text-gray text-xl-left text-center">{{autor.description}}</p>
        </div>
    </div>
    <div class="mb-5" :style="`background: #fbfbfb;`">
        <div class="container pt-5">
            <p class="font-glacial-bold font-56 text-xl-left text-center">experiência profissional</p>
            <div class="row justify-content-between mb-xl-3 mb-0 pb-2">
                <div class="col-xl-5" v-for="(d, index) in autor.experiencia" :key="index">
                    <b-media>
                        <p slot="aside" class="font-regular" :style="`font-size: 36px; color: #ffb09f`">
                            <strong>{{d.year}}</strong>
                        </p>
                        <div class="font-glacial-bold mt-1" :style="`font-size: 18px;`">
                            <h1 class="font-glacial-bold font-18 text-uppercase">
                                {{d.title}}
                            </h1>
                        </div>
                        <div class="font-glacial-regular text-gray mb-5 pb-2">
                            {{d.descricao_experiencia}}
                        </div>
                        
                    </b-media>
                        
                </div>
            </div>
        </div>
    </div>
    <div class="container pb-5">
        <h4 class="font-glacial-bold font-56 text-xl-left text-center">formação acadêmica</h4>
        <p class="font-glacial-regular font-20 text-gray text-xl-left text-center">{{autor.formacao}}</p>

    </div>

    <div class="container mb-5 pb-5">
    <div class="row">
        <h2 class="font-glacial-bold font-56 text-xl-left text-center" :style="`width: 100%`">
            outros artigos
        </h2>
    </div>
        <div class="row justify-content-center">
            <div class="col-xl-12 col-10">
                <slick :options="slickOptions" v-if="posts">
                    <div v-for="(d, index) in posts" :key="index">
                        <div class="mt-xl-5 pr-2 btn-pointer" @click="routeTo({name:'materia', params:{slug:d.slug}})">
                            <div class="blog-item border-transparent border-radius-0 mt-3 mt-lg-0">
                                <div  class="card-body card text-white card-cursos p-0 border-0 border-radius-0"
                                    :style="`background-image: url(${d.better_featured_image.source_url})`">
                                </div>
                                <div class="row no-gutters text-overflow">
                                    <div class="col-xl-11 col-10 bg-white box-curso">
                                        <h5 class="extra-bold mt-3 ml-3 mb-0 font-glacial-bold box-titulo">
                                            {{d.title.rendered}}
                                        </h5>
                                        <div class="arrow ml-3 mt-4 mb-4">
                                            <img src="/wp-content/themes/rhiza\src/assets/arrow.png">
                                        </div>
                                        <div>
                                            <div class="font-glacial-regular text-gray ml-3 descricao-curso">
                                                {{removeHTML(d.content.rendered)}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </slick>
            </div>
        </div>
    </div>
</div>
</template>
<script>

export default {
    props:{
        data: null,
    },

    data(){
        return{
            autor: null,
            posts: null,

            slickOptions:{
                arrows: true,
                slidesToShow: 4,
                responsive: [
                    {
                        breakpoint: 1400,
                        settings:{
                            slidesToShow: 1,
                        }
                    }
                ]
            }
        }
    },

    created() {
        this.loadPosts()
        this.retrievePost()

        if (this.autor) {
            var arrTitle = document.title.split('|');
            var [baseTitle] = arrTitle.slice(-1);
            
            var d = document.createElement('div');
            d.innerHTML = `${this.autor.title.rendered} | ${baseTitle}`
            document.title = d.innerText
        }
    },

    methods:{
        removeHTML(text){
            return text.replace(/<.*?>/g, '');
        },

        async retrievePost(){
            var url = window.SETTINGS.API_BASE_PATH + "posts?_embed&slug=" + this.$route.params.name

            var response = await axios.get(url)

            url = window.SETTINGS.API_BASE_PATH + "posts/" + response.data[0].id + "?_embed"

            response = await axios.get(url)

            this.autor = response.data
            this.autor = this.autor.acf
        },
        async loadPosts(){
            var url = window.SETTINGS.API_BASE_PATH + "posts?_embed&categories=2"

            var response = await axios.get(url)
            this.posts = response.data
        },

        routeTo(obj){
            this.$router.push(obj)

        },
    },

}
</script>



// WEBPACK FOOTER //
// src/components/autor.vue